import { Stores } from './constants';
import { deleteData, getDataByKey, initDB, setData } from './idb';
import type { TaskData } from './types';
export const getTaskData = async <T,>(key: string) => {
  try {
    await initDB();
    const taskData = await getDataByKey<TaskData<T>>(Stores.Task, key);
    return taskData;
  } catch (error) {
    console.error('Error getting task data:', error);
    return null;
  }
};
export const setTaskData = async <T,>(taskData: TaskData<T>) => {
  try {
    await initDB();
    await setData(Stores.Task, taskData);
    return true;
  } catch (error) {
    console.error('Error setting task data:', error);
    return false;
  }
};
export const deleteTaskData = async (key: string) => {
  try {
    await initDB();
    await deleteData(Stores.Task, key);
    return true;
  } catch (error) {
    console.error('Error deleting task data:', error);
    return false;
  }
};